import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"
import { currentUrl } from "../../../url"

export const itemsApi = createApi({
  reducerPath: "itemsApi",
  tagTypes: ["Item"],
  refetchOnMountOrArgChange: true,
  baseQuery: fetchBaseQuery({
    baseUrl: currentUrl,
    prepareHeaders: (headers) => {
      const accessToken = localStorage.getItem("accessToken")
      if (accessToken) {
        const token = accessToken.startsWith("Bearer ")
          ? accessToken
          : `Bearer ${accessToken}`
        headers.set("Authorization", token)
        headers.set("Accept", "application/json")
        headers.set("Content-Type", "application/json")
      }
      return headers
    },
  }),
  endpoints: (build) => ({
    // GET /finance/transaction-categories?page=1
    getItems: build.query({
      query: (params = {}) => {
        const { page = 1, per_page = 10, type } =
          typeof params === 'number' ? { page: params } : params
        let url = `/master/finance/transaction-categories?page=${page}&per_page=${per_page}`
        if (type) url += `&type=${type}`
        return url
      },
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: "Item", id })),
              { type: "Item", id: "LIST" },
            ]
          : [{ type: "Item", id: "LIST" }],
    }),

    // GET /finance/transaction-categories/{id}
    getItem: build.query({
      query: (id) => `/master/finance/transaction-categories/${id}`,
      providesTags: (result, error, id) => [{ type: "Item", id }],
    }),

    // POST /finance/transaction-categories
    createItem: build.mutation({
      query: (body) => ({
        url: `/master/finance/transaction-categories`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Item", id: "LIST" }],
    }),

    // PATCH /finance/transaction-categories/{id}
    updateItem: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/master/finance/transaction-categories/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Item", id: "LIST" },
        { type: "Item", id },
      ],
    }),

    // DELETE /finance/transaction-categories/{id}
    deleteItem: build.mutation({
      query: (id) => ({
        url: `/master/finance/transaction-categories/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "Item", id: "LIST" },
        { type: "Item", id },
      ],
    }),
  }),
})

export const {
  useGetItemsQuery,
  useGetItemQuery,
  useCreateItemMutation,
  useUpdateItemMutation,
  useDeleteItemMutation,
} = itemsApi
